export default [
  'onClick',
  '$uibModalInstance',
  'config',
  function (onClick, $uibModalInstance, config) {
    this.identificationUrl = config.get('lkUrl') + 'identification';
    this.onClick = () => {
      $uibModalInstance.close('identificationError');
      onClick();
    };
  },
];
